// extracted by mini-css-extract-plugin
export default {"Jobs":"styles_Jobs__dgTOn","scroll":"styles_scroll__kYaZW","noFavorites":"styles_noFavorites__fP3Cg"};